<template>
    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.486848 10.217L10.7996 0.378741C11.7023 -0.482519 13.125 0.216652 13.125 1.55453V6.73653C22.5369 6.85557 30 8.93949 30 18.7934C30 22.7706 27.6808 26.7107 25.1172 28.7707C24.3172 29.4135 23.1771 28.6067 23.4721 27.5646C26.1289 18.1777 22.2119 15.6857 13.125 15.5412V21.2321C13.125 22.5721 11.7012 23.2681 10.7996 22.4079L0.486848 12.5686C-0.161843 11.9497 -0.162722 10.8369 0.486848 10.217Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: "SVGArrowBack"
}
</script>

<style scoped>

</style>
